export default __webpack_public_path__ + "static/media/appleexpert.52ab4fd6.png";